import { Dispatch, SetStateAction, useState } from "react";

interface UseRegisterReturnData {
  registrationSuccessful: boolean;
  setRegistrationSuccessful: Dispatch<SetStateAction<boolean>>;
}

export const useRegister = (): UseRegisterReturnData => {
  const [registrationSuccessful, setRegistrationSuccessful] = useState(false);

  return {
    registrationSuccessful,
    setRegistrationSuccessful,
  };
};
